// extracted by mini-css-extract-plugin
export default {"alertsWrapper":"widgets-contacts-and-settings-components-NotifierWrapper-NotifierWrapper__alertsWrapper--Auzjf"};